/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Icon from 'material/graphic/icon/icon';
// utils
import { generateClasses } from 'utils/generators';
// styles
import injectSheet from 'react-jss';
import styles from 'material/pagination/pagination_styles';



/* ========== ~~~~~~~~~~ PAGINATION : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Pagination extends Component {
	constructor(props) {
		super(props);
		this.state = { prevDisabled: true, nextDisabled: false };
	}
	componentDidUpdate(prevProps) {
		if (this.props.currentIndex !== prevProps.currentIndex) {
			this.setDisabledArrowStates();
		}
	}
	setDisabledArrowStates = () => {
		this.setState({
			prevDisabled: this.props.currentIndex <= this.props.itemsPerPage ? true : false,
			nextDisabled: this.props.currentIndex >= this.props.totalItems ? true : false
		});
	}
	handlePrevious = (e) => { 
		this.props.handlePrevious('previous');
	}
	handleNext = (e) => { 
		this.props.handleNext('next');
	}
	handleCurrentItems = (prevProps) => {
		const endNumbers = this.props.currentIndex > this.props.totalItems ? this.props.totalItems : this.props.currentIndex; // make sure we dont display higher number than the total amount of items
		return `${(this.props.currentIndex + 1) - this.props.itemsPerPage}-${endNumbers}`;
	}
	render() {
		return (
	        <div className={`pagination ${generateClasses(this.props)} ${this.props.classes.pagination}`}>
	        	<span className={`arrow previous disabled-${this.state.prevDisabled}`} onClick={this.handlePrevious}><Icon name={`angle-left`} /></span>
	        	<span className={`status`}>
	        		<span className={`display`}>
	        			<span className={`current`}>{this.handleCurrentItems()}</span> of <span className={`total`}>{this.props.totalItems}</span>
	        		</span>
	        	</span>
	        	<span className={`arrow next disabled-${this.state.nextDisabled}`} onClick={this.handleNext}><Icon name={`angle-right`} /></span>
	        </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Pagination);